import { executeFunctionAfterHandler } from "@1js/acui-common";

export { getPropsWithMenuDismiss } from "@1js/acui-menu";

export function getGalleryPropsWithMenuDismiss<
  T extends { onGalleryButtonExecute?: (...args: any[]) => void }
>(props: T, dismissMenu: () => void): T {
  return {
    ...props,
    onGalleryButtonExecute: executeFunctionAfterHandler(
      props.onGalleryButtonExecute,
      dismissMenu
    ),
  };
}
